export const live = {
    zbz: "Sedang Siaran Langsung",
    ljks: "Mulai Sekarang",
    hmyzb: "Anda belum pernah melakukan siaran langsung~",
    zbyg: "Jadwal Siaran Langsung",
    yjs: "Telah Berakhir",
    jszb: "Akhiri Siaran Langsung",
    gbzb: "Tutup Siaran Langsung",
    jxzb: "Lanjutkan Siaran Langsung",
    bctp: "Simpan Gambar",
    fxlj: "Bagikan Tautan",
    zbydk: "Siaran langsung terputus, harap tunggu...",
    fh: "Kembali",
    wjcdypsb: "Tidak terdeteksi perangkat audio",
    czsb: "Operasi Canvas gagal:",
    tpjzsb: "Gagal memuat gambar, harap periksa apakah URL benar dan gambar dapat diakses",
    zbjl: "Riwayat Siaran Langsung",
    sqjl: "Riwayat Pengajuan",
    lts: "Ruang Obrolan",
    ren: "orang",
    gdcy: "Anggota Lainnya",
    cy: "Anggota",
    jcjy: "Buka Bisukan",
    jy: "Bisukan",
    qbjy: "Bisukan Semua",
    zbjs: "Pengenalan Siaran Langsung",
    srnr: "Silakan masukkan konten",
    tczbj: "Anda telah dikeluarkan dari ruang siaran langsung",
    qd: "Konfirmasi",
    zbjjjs: "Siaran langsung Anda akan otomatis berakhir dalam 10 menit!",
    zbsc: "Durasi Siaran Langsung:",
    ljgkrs: "Total Penonton:",
    dzs: "Jumlah Suka:",
    zbjies: "Siaran Langsung Berakhir",
    ybjy: "Anda telah dibisukan",
    jycg: "Berhasil Membuka Bisukan",
    jinycg: "Berhasil Membisukan",
    qbjinycg: "Berhasil Membisukan Semua",
    qbjycg: "Berhasil Membuka Bisukan Semua",
    cwzb: "Menjadi Streamer",
    lxgzry: "Hubungi staf untuk menjadi streamer",
    lxfs: "Kontak",
    zb: "Siaran Langsung",
    xkt: "Kelas Biking",
    sqzb: "Ajukan Siaran Langsung",
    bczbzt: "Tema Siaran Langsung Ini",
    srzt: "Silakan masukkan tema",
    bczbjj: "Pengenalan Siaran Langsung Ini",
    kbsj: "Waktu Mulai",
    xzrisj: "Pilih Tanggal dan Waktu",
    tishi: "Peringatan",
    dksdzb: "Ada 1 siaran langsung yang akan dimulai pada waktu ini",
    cxsj: "Durasi",
    xzsc: "Pilih Durasi",
    fmt: "Gambar Sampul",
    fmtbnwk: "Gambar sampul tidak boleh kosong",
    sc: "Unggah",
    yssc: "Maksimal 10MB, harap kompres sebelum mengunggah",
    sccct: "Harap unggah gambar berukuran 360*170",
    tjsq: "Kirim Pengajuan",
    tpcj: "Pemotongan Gambar",
    tzcjwz: "Sesuaikan posisi bingkai potong, pilih area yang akan dipertahankan",
    scdtp: "Gambar yang Diunggah",
    yl: "Pratinjau (360×170)",
    cjtp: "Potong Gambar",
    quxiao: "Batal",
    qsrzbjj: "Silakan masukkan pengenalan siaran langsung",
    qxzrq: "Silakan pilih tanggal",
    qxzsc: "Silakan pilih durasi",
    kssjdydqsj: "Waktu mulai harus lebih besar dari waktu saat ini",
    sctxtpdx: "Ukuran gambar avatar yang diunggah tidak boleh lebih dari 10MB!",
    tjcg: "Pengajuan Berhasil",
    jkshnr: "Kami akan segera meninjau konten pengajuan Anda",
    hmysqgzb: "Anda belum pernah mengajukan siaran langsung~",
    shz: "Sedang Ditinjau",
    tongg: "Disetujui",
    jujue: "Ditolak",
    yugao: "Jadwal",
    huifang: "Rekaman",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/live/ba.js